import colors from './colors';
import breakpoints from './breakpoints';

const theme = {
  colors,
  breakpoints,
};

export default theme;
